import { render } from "./NewsCard.vue?vue&type=template&id=195ac00c&scoped=true"
import script from "./NewsCard.vue?vue&type=script&lang=js"
export * from "./NewsCard.vue?vue&type=script&lang=js"

import "./NewsCard.vue?vue&type=style&index=0&id=195ac00c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-195ac00c"

export default script